import axios from "axios";
import Cookies from "js-cookie";
import https from "https";
import logout from "@/function/logout";

const agent = new https.Agent({
  rejectUnauthorized: false,
});

const httpService = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
  withCredentials: true,
  httpsAgent: agent,
});

httpService.interceptors.request.use(
  (config) => {
    const token = Cookies.get("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);
httpService.interceptors.response.use(
  (res) => res,
  (err) => {
    const originalConfig = err.config;
    if (err.response && err.response.status === 401 && !originalConfig._retry) {
      originalConfig._retry = true;
      const token = Cookies.get("AccessToken");
      if (token) {
        err.response.headers.Authorization = `Bearer ${token}`;
      } else {
        logout();
      }
    }
    return Promise.reject(err);
  }
);
const http = {
  get: httpService.get,
  post: httpService.post,
  delete: httpService.delete,
  put: httpService.put,
  patch: httpService.patch,
};
export default http;
